<template>
  <transition name="EndControl">
    <div class="EndControl" v-if="slugIsIn(['monde', 'monde:1', 'monde:2']) || this.$route.meta.name == 'artwork'">
      <router-link :to="{ name: $route.name, params: { page: 'open' }}" class="EndControl__menu Btn">
        <svg><use :xlink:href="'#' + require('./sprite/arrow.svg').default.id" /></svg>
        {{ trans('menu') }}
      </router-link>
      <a class="EndControl__restart Btn" href="/">
        {{ trans('restart') }}
      </a>
      <transition name="EndControl__escape">
        <div class="EndControl__escape" v-if="this.$route.meta.name == 'artwork' && !$route.params.id && is_locked">
          <img :src="require('@/components/defis/img/assets/important.png')"/>
          {{ trans('press') }}
        </div>
      </transition>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'EndControl',
  translations: {
    fr: {
      menu: 'En savoir plus sur les artistes',
      restart: "Réessayer l'expérience",
      press: `Appuyer sur « Esc » pour retrouver le curseur`,
    },
    en: {
      menu: 'Find out more about the artists',
      restart: "Try the experience again",
      press: `Tap on "Esc" to return to your cursor`
    },
  },
  computed: {
    is_locked() { return this.$store.getters['app/is_locked'] }
  },
}
</script>

<style lang="stylus">
@import '~@/config/Settings'

.EndControl

  transition opacity 1s, transform .5s
  &-enter
  &-leave-active
    opacity 0
    transform translateX(50px)

  &__menu
  &__restart
    bottom inherit
    right inherit
    top 15px

  &__menu
    left 80px
    padding-left 50px
    svg
      position absolute
      left 25px
      width 12px
      transform rotate(-180deg)

  &__restart
    color white
    left 470px
    background linear-gradient(to right, rgba(grad_blue, 1), rgba(grad_green, 1))
    &:hover
      color white

  &__escape 
    position absolute
    top 80px
    left 80px
    font-size 12px
    background black
    padding 2px 14px 2px 42px
    border-radius 20px
    transition opacity 1s

    &-enter
    &-leave-active
      opacity 0


    & img 
      position absolute
      width 20px
      left 12px 
      top 6px

</style>



// WEBPACK FOOTER //
// src/components/controls/EndControl.vue